export default __webpack_public_path__ + "static/media/1-kilo-32-15-oz-generic-gold-bar-999-fine-ira-approved--132084749679882532.47c45c2c.jpg";